export const pairedDevices = (serialNumber = ""): string =>
  `/paired-devices/${serialNumber}`;
